import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class ToggleIsClientModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class ToggleIsClientModalData {
    account: Account;
    constructor(account?) {
        this.account = account;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/toggle.is.client/toggle.is.client.modal.provider.ts